import React, { memo, useCallback, useMemo } from 'react';
import { Icon } from '../../../icon';
import { Button } from './../../../button';
import { TableSearch } from './table-search';
import { SearchBlockWrap, TextButtonStyled } from './styled';
import { useLazyQuery } from './useLazyQuery';
export const SearchBlock = memo(({ query, setQuery, lazy = true, setAdvancedSearch, CustomButtonBlock, withSearchDropdown, searchButtonVariant = 'outline' }) => {
    const [localQuery, setSearchValue, searchTrigger] = useLazyQuery({
        query,
        setQuery,
        lazy
    });
    const resetSearch = useCallback(() => {
        setSearchValue('');
        searchTrigger('');
    }, [setSearchValue, searchTrigger]);
    const isShowResetSearchBtn = useMemo(() => !!localQuery, [localQuery]);
    // const isShowSaveRequestBtn = useMemo(() => !!localQuery, [localQuery]);
    return (React.createElement(SearchBlockWrap, null,
        React.createElement(TableSearch, { searchValue: localQuery || '', setSearchValue: setSearchValue, searchData: searchTrigger, isShowResetSearchBtn: isShowResetSearchBtn, resetSearch: resetSearch, prependButton: withSearchDropdown || undefined }),
        lazy && (React.createElement(Button, { variant: searchButtonVariant, text: "Search", onClick: () => searchTrigger(), disabled: searchButtonVariant === 'filled'
                ? false
                : localQuery === undefined || localQuery.length === 0 })),
        Boolean(CustomButtonBlock) && CustomButtonBlock,
        setAdvancedSearch ? (React.createElement(TextButtonStyled, { onClick: setAdvancedSearch },
            "Advanced Search ",
            React.createElement(Icon, { name: "arrow_forward" }))) : undefined));
});
